<template>
  <div class="main-content">
    <!-- проверка по всем получаемым данным-->
    <a-t-loader v-if="isLoadingClient" />

    <template v-else>
      <div class="page-content">
        <div class="container">
          <section class="created-invoices">
            <div class="page-title">
              <h2>Create Invoice</h2>
            </div>

            <div class="information-block js-collapse" :class="{'is-collapsed': collapse.information}">
              <div class="information-block_header">
                <div class="information-block_title">
                  <span>Group Information</span>
                </div>
                <div class="information-block_hide">
                  <button
                      type="button"
                      data-opened="Hide"
                      data-closed="Show"
                      :class="[
                      'btn',
                      'btn--collapse',
                      'js-collapse-trigger',
                      {'is-active': collapse.information},
                    ]"
                  @click="collapse.information = !collapse.information">
                    <div class="btn--collapse__icon">
                      <svg width="1em" height="1em" class="icon icon-collapse">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>

              <div
                  id="total-sect"
                  :class="['make-story__collapse js-collapse summary-section']"
                  v-if="calculationResult">
                <div
                    class="make-story__collapse__inner  js-collapse-inner"
                    v-if="calculationResult">
                  <div class="breakdown-cost__pax">
                    <span class="breakdown-cost__pax-name">Pax:</span>
                    <span class="breakdown-cost__pax-desc">{{participantsPax.length}} </span>
                    <span class="breakdown-cost__pax-desc">(</span>
                    <span v-for="(item, index) in participantsPax" :key="index" class="breakdown-cost__pax-desc">
                      {{ item }}
                    </span>
                    <span class="breakdown-cost__pax-desc">)</span>
                  </div>

                  <div class="breakdown-cost__summary">
                    <div class="breakdown-cost__summary__total">
                      <div
                          class="breakdown-cost__summary__total__line breakdown-cost__summary__total__line_head">
                        <span class="breakdown-cost__summary__total__descr"
                        >Participant</span
                        >
                        <span class="breakdown-cost__summary__total__holder">

                          <span class="breakdown-cost__summary__total__val"
                          >Total Amount</span
                          >
                        </span>
                      </div>
                      <div
                          class="breakdown-cost__summary__total__line"
                          v-for="(item, index) in sorteredParticipants"
                          :key="index">
                        <span class="breakdown-cost__summary__total__descr">
                          {{ item.info }}
                        </span>
                        <span
                            class="breakdown-cost__summary__total__holder breakdown-cost__summary__total__holder--gap">

                          <span class="breakdown-cost__summary__total__val"
                          >{{ numberWithCommas(item.totalAmount)
                            }} {{
                              getCurrencySign(calculationResult.breakdownCost.currency)
                            }}</span
                          >
                        </span>
                      </div>
                    </div>

                  </div>
                  <div class="breakdown-cost__result">
                    <div class="summary-result_item">
                      <span class="summary-result_item-name">Total Amount:</span>
                      <span class="summary-result_item-total">
                        {{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}
                        {{numberWithCommas(calculationResult.breakdownCost.summary.grandTotal)}}</span>
                    </div>
<!--                    <div class="summary-result_item">-->
<!--                      <span class="summary-result_item-name">Amount Paid:</span>-->
<!--                      <span class="summary-result_item-total">0 ???</span>-->
<!--                    </div>-->
<!--                    <div class="summary-result_item">-->
<!--                      <span class="summary-result_item-name">Remain Balance:</span>-->
<!--                      <span class="summary-result_item-total">0 ???</span>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>

            </div>

            <div class="cost-block js-collapse" :class="{'is-collapsed': collapse.breakdownCost}">
              <div class="cost-block_header">
                <div class="cost-block_title">
                  <span>Full Breakdown Cost</span>
                </div>
                <div class="cost-block_hide">
                  <button
                      type="button"
                      data-opened="Hide"
                      data-closed="Show"
                      :class="[
                      'btn',
                      'btn--collapse',
                      'js-collapse-trigger',
                      {'is-active': collapse.breakdownCost},
                    ]"
                  @click="collapse.breakdownCost = !collapse.breakdownCost">
                    <div class="btn--collapse__icon">
                      <svg width="1em" height="1em" class="icon icon-collapse">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>

              <div
                  class="make-story__collapse__inner  js-collapse-inner"
                  id="cost-to-print">



                <div class="breakdown-cost__table">
                  <div class="breakdown-cost__info">
                    <div class="breakdown-cost__info__title">
                      <span
                      >TOTAL DAYS PROGRAMM:
                        <b>{{ calculationResult.breakdownCost.totalDays }}</b></span
                      >
                    </div>
                    <div class="breakdown-cost__info__range">
                      <p>
                        Start: <b>{{ calculationResult.breakdownCost.startDate }}</b>
                        <span class="breakdown-cost__info__range__divider"
                        >/</span
                        >
                        End:
                        <b>{{ calculationResult.breakdownCost.endDate }}</b>
                      </p>
                    </div>
                  </div>
                  <div class="form-control-group make-story__checkbox-2">
                    <label for="chk_41" class="form-control-checkbox">
                      <input
                          id="chk_41"
                          type="checkbox"
                          v-model="showNames" /><span
                        class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                    ><span class="form-control-checkbox__name"
                    >Show clients names</span
                    >
                    </label>

                    <label for="chk_43" class="form-control-checkbox">
                      <input id="chk_43" type="checkbox" v-model="show0" /><span
                        class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                    ><span class="form-control-checkbox__name">Show.000</span>
                    </label>
                  </div>
                  <div class="breakdown-cost__table__head">
                    <div class="col col-pax"><span>Pax</span></div>
                    <div class="col col-price"><span>Price</span></div>
                  </div>
                  <div
                      class="breakdown-cost__table__row"
                      v-if="
                        (calculationResult.breakdownCost.transferCost &&
                          calculationResult.breakdownCost.transferCost.transfers
                            .length) ||
                        (calculationResult.breakdownCost.transferCost &&
                          calculationResult.breakdownCost.transferCost.errors.length)
                      ">
                    <div class="breakdown-cost__table__row__title">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--blue">
                        <svg width="1em" height="1em" class="icon icon-car">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-car"></use>
                        </svg>
                      </div>
                      <span>Transfers Cost</span>
                    </div>
                    <div
                        class="breakdown-cost__table__line breakdown-cost__table__line-parent">
                      <div
                          class="breakdown-cost__table__line__item"
                          v-for="(item, index) in calculationResult.breakdownCost
                            .transferCost.transfers"
                          :key="index">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, i) in item.participants"
                              :key="i"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                        <span
                            class="breakdown-cost__table__line__item__warning form-control__help-icon__warning"
                            v-if="item.warning">
                            <svg
                                class="icon icon-important important-icon">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                            </svg>
                          </span>
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Transfer Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.transferCost
                                  .totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.transferCost
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.transferCost.errors.length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.transferCost.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                      class="breakdown-cost__table__row"
                      v-if="calculationResult.breakdownCost.safariCost">
                    <div
                        class="breakdown-cost__table__row__title form-control__help">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--orange">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-safari">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-safari"></use>
                        </svg>
                      </div>
                      <span>Safari Cost</span>
                      <span class="form-control__help-icon">
                          <span class="form-control__help-content"
                          >Подробнее читайте в нашем <a>FAQ</a></span
                          >
                          <img src="/images/useful/svg/help-icon.svg" alt="" />
                        </span>
                    </div>
                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.safariCost.parkFees.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Park Fees</span
                        >
                      <div
                          class="breakdown-cost__table__line__item"
                          v-for="(item, index) in calculationResult.breakdownCost
                            .safariCost.parkFees"
                          :key="index">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }} ({{ item.days }} Day{{
                            item.days > 1 ? 's' : ''
                          }})
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, idx) in item.participants"
                              :key="idx"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}
                            <span
                                class="form-control__help-icon"
                                v-if="item.warning">
                              <span class="form-control__help-content"
                              >This price substantially differs from regular
                                values, please check it manually.</span
                              >
                              <svg
                                  class="icon icon-important important-icon">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                              </svg>
                            </span>
                          </span>
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.safariCost.activities.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Safari Activities</span
                        >
                      <div
                          class="breakdown-cost__table__line__item"
                          v-for="(item, index) in calculationResult.breakdownCost
                            .safariCost.activities"
                          :key="index">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, idx) in item.participants"
                              :key="idx"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.safariCost.hotels.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Hotels</span
                        >
                      <div
                          v-for="(item, index) in calculationResult.breakdownCost
                            .safariCost.hotels"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                            <span
                                class="breakdown-cost__table__line__item__name"
                            >{{ item.name }} ({{ item.nights }} night{{
                                item.nights === 1 ? '' : 's'
                              }})</span
                            >
                        </div>
                        <div
                            class="breakdown-cost__table__line__subitem"
                            v-for="(room, i) in item.rooms"
                            :key="i">
                          <div
                              class="breakdown-cost__table__line__subitem__name">
                            {{ room.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in room.participants"
                                :key="idx"
                                v-if="showNames">
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name"
                                ><span>{{ client.info }}</span>
                                </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(calculationResult.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ room.roomCount }} Room</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0
                                ? room.price
                                : removeFractional(room.price)
                          }}{{
                            getCurrencySign(calculationResult.breakdownCost.currency)
                          }}<span
                              class="form-control__help-icon"
                              v-if="room.warning">
                                <span class="form-control__help-content"
                                >This price substantially differs from regular
                                  values, please check it manually.</span
                                ><svg
                              class="icon icon-important important-icon">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use></svg></span
                          ></span>
                        </div>
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="calculationResult.breakdownCost.safariCost.carRental">
                        <span class="breakdown-cost__table__line__title"
                        >Transfers</span
                        >
                      <div class="breakdown-cost__table__line__item">
                        <div class="breakdown-cost__table__line__item__name">
                          Rent safari car
                          <!-- <div class="breakdown-cost__table__line__subsubitem" v-for="(item, index) in totalPrice.breakdownCost.safariCost.carRental.participants" :key="index" v-if="showNames"><span
              class="breakdown-cost__table__line__subsubitem__name">{{item}}</span>
              </div> -->
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{
                            calculationResult.breakdownCost.safariCost.carRental.pax
                          }}
                            Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.safariCost.carRental
                                  .price
                              : removeFractional(
                                  calculationResult.breakdownCost.safariCost
                                      .carRental.price
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Safari Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.safariCost.totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.safariCost
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.safariCost.errors.length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.safariCost.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                      class="breakdown-cost__table__row"
                      v-if="calculationResult.breakdownCost.climbingCost">
                    <div
                        class="breakdown-cost__table__row__title form-control__help">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--green">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-climbing">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-climbing"></use>
                        </svg>
                      </div>
                      <span>Climbing Cost </span>
                      <span class="form-control__help-icon">
                          <span class="form-control__help-content"
                          >Подробнее читайте в нашем <a>FAQ</a></span
                          >
                          <img src="/images/useful/svg/help-icon.svg" alt="" />
                        </span>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-for="(item, index) in calculationResult.breakdownCost
                          .climbingCost.routes"
                        :key="index">
                        <span class="breakdown-cost__table__line__title"
                        >Climbing
                          {{ item.tourLeader ? ' (Tour Leader)' : '' }}</span
                        >
                      <div class="breakdown-cost__table__line__item">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.mountName }} via {{ item.routeName }} Route
                          {{ item.days }} days
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, idx) in item.participants"
                              :key="idx"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.climbingCost
                            .additionalOptions.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Additional options</span
                        >

                      <div
                          class="breakdown-cost__table__line__item"
                          v-for="(item, index) in calculationResult.breakdownCost
                            .climbingCost.additionalOptions"
                          :key="index">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, idx) in item.participants"
                              :key="idx"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.climbingCost.hotels.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Accomodation</span
                        >
                      <div
                          v-for="(item, index) in calculationResult.breakdownCost
                            .climbingCost.hotels"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                            <span
                                class="breakdown-cost__table__line__item__name"
                            >{{ item.name }} ({{ item.nights }} night{{
                                item.nights === 1 ? '' : 's'
                              }})</span
                            >
                        </div>
                        <div
                            class="breakdown-cost__table__line__subitem"
                            v-for="(room, i) in item.rooms"
                            :key="i">
                          <div
                              class="breakdown-cost__table__line__subitem__name">
                            {{ room.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in room.participants"
                                :key="idx"
                                v-if="showNames">
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name"
                                ><span>{{ client.info }}</span>
                                </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(calculationResult.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ room.roomCount }} Room</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0
                                ? room.price
                                : removeFractional(room.price)
                          }}{{
                            getCurrencySign(calculationResult.breakdownCost.currency)
                          }}<span
                              class="form-control__help-icon"
                              v-if="room.warning">
                                <span class="form-control__help-content"
                                >This price substantially differs from regular
                                  values, please check it manually.</span
                                ><svg
                              class="icon icon-important important-icon">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use></svg></span
                          ></span>
                        </div>
                      </div>
                    </div>

                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Climbing Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.climbingCost
                                  .totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.climbingCost
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.climbingCost.errors.length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.climbingCost.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                      class="breakdown-cost__table__row"
                      v-if="
                        calculationResult.breakdownCost.islandCost &&
                        (calculationResult.breakdownCost.islandCost.activities
                          .length ||
                          calculationResult.breakdownCost.islandCost.transfers
                            .length ||
                          calculationResult.breakdownCost.islandCost.hotels.length ||
                          calculationResult.breakdownCost.islandCost.errors.length)
                      ">
                    <div class="breakdown-cost__table__row__title">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--red">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-zanzibar">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                        </svg>
                      </div>
                      <span>Island Cost</span>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-for="(item, index) in calculationResult.breakdownCost
                          .islandCost.activities"
                        :key="index">
                      <div class="breakdown-cost__table__line__item">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, i) in item.participants"
                              :key="i"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.islandCost.transfers.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Transfer</span
                        >
                      <div
                          class="breakdown-cost__table__line__item"
                          v-for="(item, index) in calculationResult.breakdownCost
                            .islandCost.transfers"
                          :key="index">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, i) in item.participants"
                              :key="i"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__line"
                        v-if="
                          calculationResult.breakdownCost.islandCost.hotels.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Hotels</span
                        >
                      <div
                          v-for="(item, index) in calculationResult.breakdownCost
                            .islandCost.hotels"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                            <span
                                class="breakdown-cost__table__line__item__name"
                            >{{ item.name }} ({{ item.nights }} night{{
                                item.nights === 1 ? '' : 's'
                              }})</span
                            >
                        </div>
                        <div
                            class="breakdown-cost__table__line__subitem"
                            v-for="(room, i) in item.rooms"
                            :key="i">
                          <div
                              class="breakdown-cost__table__line__subitem__name">
                            {{ room.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in room.participants"
                                :key="idx"
                                v-if="showNames">
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name"
                                ><span>{{ client.info }}</span>
                                </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(calculationResult.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ room.roomCount }} Room</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0
                                ? room.price
                                : removeFractional(room.price)
                          }}{{
                            getCurrencySign(calculationResult.breakdownCost.currency)
                          }}
                          <!--                            <span-->
                          <!--                                class="form-control__help-icon form-control__special-offer">-->
                          <!--											<span class="form-control__help-content">-->
                          <!--											<p>Special Offer: <span>Early Bird</span></p>-->
                          <!--											<p>Hotel booked 30 days in advance, provide 15% discount</p>-->
                          <!--											</span>-->
                          <!--											<img src="/images/icons/special-tag.svg" alt="">-->
                          <!--										</span>-->
                          <!-- <span class="form-control__help-icon" v-if="room.warning"> 	<span class="form-control__help-content">This price substantially differs from regular values, please check it manually.</span><svg  width="1.6rem" height="1.6rem" class="icon icon-important important-icon">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                </svg></span>
                 -->
                            </span>
                        </div>
                      </div>
                    </div>

                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Island Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.islandCost.totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.islandCost
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>

                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.islandCost.errors.length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.islandCost.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>

                  <!--Flight tickets start-->
                  <div
                      class="breakdown-cost__table__row"
                      v-if="
                        calculationResult.breakdownCost.flightTickets.tickets.length ||
                        calculationResult.breakdownCost.flightTickets.errors.length
                      ">
                    <div class="breakdown-cost__table__row__title">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--blue">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-airplane">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                        </svg>
                      </div>
                      <span>Flight tickets</span>
                    </div>
                    <div
                        class="breakdown-cost__table__line"
                        v-for="(item, index) in calculationResult.breakdownCost
                          .flightTickets.tickets"
                        :key="index">
                      <div class="breakdown-cost__table__line__item">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div class="breakdown-cost__table__line__info">
                              <span
                                  class="breakdown-cost__table__line__item__box"
                              >Airlines: <i>{{ item.airline }}</i>
                              </span>
                            <span
                                class="breakdown-cost__table__line__item__box"
                            >Dept Time:
                                <i>{{
                                    item.depTime.substring(0, 2) +
                                    ':' +
                                    item.depTime.substring(
                                        item.depTime.length - 2
                                    )
                                  }}</i></span
                            >
                          </div>
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, idx) in item.participants"
                              :key="idx"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>

                        <span class="breakdown-cost__table__line__item__pax">
                            <span v-if="item.passengers.adult15"
                            >Adult 15kg ({{
                                item.passengers.adult15.pax
                              }})</span
                            >
                            <span v-if="item.passengers.adult30"
                            >Adult 30kg ({{
                                item.passengers.adult30.pax
                              }})</span
                            >
                            <span v-if="item.passengers.child15"
                            >Child 15kg ({{
                                item.passengers.child15.pax
                              }})</span
                            >
                            <span v-if="item.passengers.child30"
                            >Child 15kg ({{
                                item.passengers.child30.pax
                              }})</span
                            >
                          </span>
                        <span
                            v-if="item.type === 'REGULAR'"
                            class="breakdown-cost__table__line__item__price">
                            <span v-if="item.passengers.adult15"
                            >{{
                                show0
                                    ? item.passengers.adult15.price
                                    : removeFractional(
                                        item.passengers.adult15.price
                                    )
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                            <span v-if="item.passengers.adult30"
                            >{{
                                show0
                                    ? item.passengers.adult30.price
                                    : removeFractional(
                                        item.passengers.adult30.price
                                    )
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                            <span v-if="item.passengers.child15"
                            >{{
                                show0
                                    ? item.passengers.child15.price
                                    : removeFractional(
                                        item.passengers.child15.price
                                    )
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                            <span v-if="item.passengers.child30"
                            >{{
                                show0
                                    ? item.passengers.child30.price
                                    : removeFractional(
                                        item.passengers.child30.price
                                    )
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </span>
                        <span v-if="item.type === 'PRIVATE'">
                            {{ item.participants[0].totalCost + '$' }}
                          </span>
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Flights Tickets Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.flightTickets
                                  .totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.flightTickets
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.flightTickets.errors.length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.flightTickets.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <!--Flight tickets end-->

                  <div
                      class="breakdown-cost__table__row"
                      v-if="
                        calculationResult.breakdownCost.airportVipServices &&
                        (calculationResult.breakdownCost.airportVipServices.vipServices
                          .length ||
                          calculationResult.breakdownCost.airportVipServices.errors
                            .length)
                      ">
                    <div
                        class="breakdown-cost__table__row__title form-control__help">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--dark-blue">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-airport">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airport"></use>
                        </svg>
                      </div>
                      <span>Airport Services</span>
                    </div>
                    <div
                        v-for="(item, index) in calculationResult.breakdownCost
                          .airportVipServices.vipServices"
                        :key="index"
                        class="breakdown-cost__table__line">
                      <div class="breakdown-cost__table__line__item">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              v-if="showNames"
                              v-for="(client, i) in item.participants"
                              :key="i"
                              class="breakdown-cost__table__line__subsubitem">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name">
                                <span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(calculationResult.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Airport Services Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.airportVipServices
                                  .totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.airportVipServices
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.airportVipServices.errors
                            .length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.airportVipServices.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>

                  <div
                      class="breakdown-cost__table__row breakdown-cost__table__row-no-line"
                      v-if="
                        (calculationResult.breakdownCost.dayTripsCost &&
                          calculationResult.breakdownCost.dayTripsCost.totalAmount) ||
                        calculationResult.breakdownCost.dayTripsCost.errors.length
                      ">
                    <div
                        class="breakdown-cost__table__row__title form-control__help">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--green-2">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-parachute">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                        </svg>
                      </div>
                      <span>Day Trips Cost</span>
                    </div>
                    <div
                        class="breakdown-cost__table__line"
                        v-for="(item, index) in calculationResult.breakdownCost
                          .dayTripsCost.activities"
                        :key="index">
                      <div class="breakdown-cost__table__line__item">
                        <div class="breakdown-cost__table__line__item__name">
                          {{ item.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, i) in item.participants"
                              :key="i"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ item.pax }} Pax</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>
                    <!-- <div class="breakdown-cost__table__line" v-if="totalPrice.breakdownCost.dayTripsCost.hotels.length"><span
              class="breakdown-cost__table__line__title">Hotels</span>
              <div v-for="(item, index) in totalPrice.breakdownCost.dayTripsCost.hotels" :key="index">
                <div class="breakdown-cost__table__line__item"><span
                class="breakdown-cost__table__line__item__name">{{item.name}} ({{item.nights}} nights)</span></div>
                <div class="breakdown-cost__table__line__subitem" v-for="(room, i) in item.rooms" :key="i"><div
                  class="breakdown-cost__table__line__subitem__name">{{room.name}}
                  <div class="breakdown-cost__table__line__subsubitem" v-for="(client, idx) in room.participants " :key="idx"><span
                  class="breakdown-cost__table__line__subsubitem__name">{{client}}</span>
                  </div></div><span
                  class="breakdown-cost__table__line__item__pax">{{room.roomCount}} Room</span><span
                  class="breakdown-cost__table__line__item__price">{{room.price}}$</span></div>
              </div>
            </div> -->
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Day Trips Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.dayTripsCost
                                  .totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.dayTripsCost
                                      .totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.dayTripsCost.errors.length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.dayTripsCost.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>

                  <div
                      class="breakdown-cost__table__row breakdown-cost__table__row-no-line"
                      v-if="
                        (calculationResult.breakdownCost.extraAccommodationCost &&
                          calculationResult.breakdownCost.extraAccommodationCost.hotels
                            .length) ||
                        calculationResult.breakdownCost.extraAccommodationCost.errors
                          .length
                      ">
                    <div
                        class="breakdown-cost__table__row__title form-control__help">
                      <div
                          class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--dark-blue">
                        <svg width="1em" height="1em" class="icon icon-house">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                        </svg>
                      </div>
                      <span>Extra Accommodation</span>
                    </div>
                    <div
                        class="breakdown-cost__table__line"
                        v-for="(item, index) in calculationResult.breakdownCost
                          .extraAccommodationCost.hotels"
                        :key="index">
                      <div class="breakdown-cost__table__line__item">
                          <span class="breakdown-cost__table__line__item__name"
                          >{{ item.name }} ({{ item.nights }} night{{
                              item.nights === 1 ? '' : 's'
                            }})</span
                          >
                      </div>
                      <div
                          class="breakdown-cost__table__line__subitem"
                          v-for="(room, idx) in item.rooms"
                          :key="idx">
                        <div
                            class="breakdown-cost__table__line__subitem__name">
                          {{ room.name }}
                          <div
                              class="breakdown-cost__table__line__subsubitem"
                              v-for="(client, i) in room.participants"
                              :key="i"
                              v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                            <span
                                class="breakdown-cost__table__line__subsubitem__name-price"
                            >{{
                                show0
                                    ? client.totalCost
                                    : removeFractional(client.totalCost)
                              }}{{
                                getCurrencySign(calculationResult.breakdownCost.currency)
                              }}</span
                            >
                          </div>
                        </div>
                        <span class="breakdown-cost__table__line__item__pax"
                        >{{ room.roomCount }} Room</span
                        ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? room.price : removeFractional(room.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}<span
                            class="form-control__help-icon"
                            v-if="room.warning">
                              <span class="form-control__help-content"
                              >This price substantially differs from regular
                                values, please check it manually.</span
                              ><svg
                            class="icon icon-important important-icon">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use></svg></span
                        ></span>
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Extra Accommodation Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.extraAccommodationCost
                                  .totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost
                                      .extraAccommodationCost.totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="
                          calculationResult.breakdownCost.extraAccommodationCost.errors
                            .length
                        ">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{
                          calculationResult.breakdownCost.extraAccommodationCost.errors.join(
                              ', '
                          )
                        }}
                      </div>
                    </div>
                  </div>

                  <div
                      class="breakdown-cost__table__row"
                      v-if="
                        calculationResult.breakdownCost.other &&
                        (calculationResult.breakdownCost.other.costs.length ||
                          calculationResult.breakdownCost.other.errors.length)
                      ">
                    <div class="breakdown-cost__table__row__title">
                      <div class="breakdown-cost__table__row__icon">
                        <svg width="1em" height="1em" class="icon icon-other">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-other"></use>
                        </svg>
                      </div>
                      <span>Other</span>
                    </div>
                    <div class="breakdown-cost__table__line">
                      <div
                          class="breakdown-cost__table__line__info"
                          v-for="(item, index) in calculationResult.breakdownCost.other
                            .costs"
                          :key="index">
                          <span
                              class="breakdown-cost__table__line__item__name"
                          >{{ item.name }}</span
                          ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? item.price : removeFractional(item.price)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Other Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.other.totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.other.totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                    <div
                        class="note-info"
                        v-if="calculationResult.breakdownCost.other.errors.length">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <div class="note-info__text">
                        {{ calculationResult.breakdownCost.other.errors.join(', ') }}
                      </div>
                    </div>
                  </div>

                  <div
                      class="breakdown-cost__table__row"
                      v-if="
                        calculationResult.breakdownCost.additionalServices &&
                        (calculationResult.breakdownCost.additionalServices.services.length)
                      ">
                    <div class="breakdown-cost__table__row__title">
                      <div class="breakdown-cost__table__row__icon">
                        <svg width="1em" height="1em" class="icon icon-additional-options">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-additional-options"></use>
                        </svg>
                      </div>
                      <span>Additional Services</span>
                    </div>
                    <div class="breakdown-cost__table__line">
                      <div
                          class="breakdown-cost__table__line__info"
                          v-for="(service, index) in calculationResult.breakdownCost.additionalServices
                            .services"
                          :key="index">
                          <span
                              class="breakdown-cost__table__line__item__name"
                          >{{ service.description }}</span
                          ><span
                          class="breakdown-cost__table__line__item__price"
                      >{{
                          show0 ? service.participant.totalCost : removeFractional(service.participant.totalCost)
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                      </div>
                    </div>
                    <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Additional Services Total:</span
                        >
                      <span class="breakdown-cost__item-total-value"
                      >{{
                          show0
                              ? calculationResult.breakdownCost.additionalServices.totalAmount
                              : removeFractional(
                                  calculationResult.breakdownCost.additionalServices.totalAmount
                              )
                        }}{{
                          getCurrencySign(calculationResult.breakdownCost.currency)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="breakdown-cost__table-total">
                  GRAND TOTAL:<span
                    class="breakdown-cost__table-total-val"
                >{{ calculationResult.breakdownCost.summary.grandTotal
                  }}{{
                    getCurrencySign(calculationResult.breakdownCost.currency)
                  }}</span
                >
                </div>
              </div>

            </div>

            <div class="bank-block">
              <div class="bank-block_title">
                <span>Bank</span>
              </div>

              <div class="bank-block_selects">
                <v-select
                    v-model="templateCreateInvoice.bankId"
                    :options="availableBanks"
                    :reduce="(item) => item.id"
                    @input="findCurrentBankSelect()"
                    :filterable="false"
                    :clearable="false"
                    :searchable="false"
                    :disabled="!hasClientContract"
                    label="shortName"
                    placeholder="Select bank"
                    class="new-select"
                    :class="{'invoice-bank-select--error': validErrorInvoice.bank}"
                >
                  <template #open-indicator>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="5"
                        viewBox="0 0 8 5"
                        fill="none">
                      <path
                          d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                          fill="#606060" />
                    </svg>
                  </template>
                  <template #option="option">
                    <div class="select__item d-center">
                      {{ option.shortName }}
                    </div>
                  </template>
                  <template #selected-option="option">
                    <div class="selected d-center">
                      {{ option.shortName }}
                    </div>
                  </template>
                </v-select>
              </div>

              <div class="bank-block_content">
                <div class="content-block">
                  <span class="content-block_title">Beneficiary</span>
                </div>
                <div class="content-block">
                  <div class="content-block_name content-block_name-fw">
                    <span>IBAN Account:</span>
                    <span>{{ currentBankSelect.ibanAccount }}</span>
                  </div>
                  <div class="content-block_name content-block_name-fw">
                    <span>Company Name:</span>
                    <span>{{ currentBankSelect.companyName }}</span>
                  </div>
                  <div class="content-block_name">
                    <span>Company Address: </span>
                    <span>{{ currentBankSelect.beneficiaryAddress }}</span>
                  </div>
                </div>
              </div>

              <div class="bank-block_content">
                <div class="content-block">
                  <span class="content-block_title">Bank of Beneficiary</span>
                </div>
                <div class="content-block">
                  <div class="content-block_name content-block_name-fw">
                    <span>SWIFT:</span>
                    <span>{{ currentBankSelect.swift }}</span>
                  </div>
                  <div class="content-block_name content-block_name-fw">
                    <span>Bank Name:</span>
                    <span>{{ currentBankSelect.name }}</span>
                  </div>
                  <div class="content-block_name">
                    <span>Bank Address:</span>
                    <span>{{ currentBankSelect.bankAddress }}</span>
                  </div>
                </div>
              </div>


            </div>

            <div class="payer-block">
              <div class="payer-block_title">
                <span>Payer</span>
              </div>

              <div class="payer-block_control">
                <div class="payer-block_control-panel">
                  <div class="control-panel_selects">
                    <v-select
                        v-model="templateCreateInvoice.payer.payerType"
                        :options="payerOptions"
                        :reduce="(item) => item.type"
                        @input="findCurrentPayerOptionsSelect()"
                        :filterable="false"
                        :clearable="false"
                        :searchable="false"
                        label="name"
                        placeholder="Select bank"
                        class="new-select"
                    >
                      <template #open-indicator>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none">
                          <path
                              d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                              fill="#606060" />
                        </svg>
                      </template>
                      <template #option="option">
                        <div class="select__item d-center">
                          {{ option.name}}
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>

                    <div
                      v-if="currentPayerOptionsSelect.payerType === 'OPERATOR'"
                      class="form-control-group">
                      <v-select
                          v-model="currentPayerSelect"
                          :options="allPartners"
                          :reduce="(item) => item"
                          @input="findCurrentPayerSelect()"
                          :filterable="false"
                          :clearable="false"
                          :searchable="false"
                          label="companyName"
                          placeholder=""
                          class="new-select new-select--partners"
                      >
                        <template #open-indicator>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none">
                            <path
                                d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                fill="#606060" />
                          </svg>
                        </template>
                        <template #option="option">
                          <div class="select__item d-center">
                            {{ option.companyName}}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div class="selected d-center">
                            {{ option.companyName }}
                          </div>
                        </template>
                      </v-select>
<!--                      <div-->
<!--                        :class="[-->
<!--                          'select-wrapper form-control__help',-->
<!--                          {'is-active': isActiveSelectPayer},-->
<!--                        ]"-->
<!--                        @click="isCurrentPayerSelect">-->
<!--                        <div class="select-trigger">-->
<!--                          <span class="select-trigger__name">{{-->
<!--                            currentPayerSelect.companyName-->
<!--                          }}</span-->
<!--                          ><span class="select-trigger__icon">-->
<!--                            <svg-->
<!--                              width="1em"-->
<!--                              height="1em"-->
<!--                              class="icon icon-chevron">-->
<!--                              <use-->
<!--                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg-->
<!--                          ></span>-->
<!--                        </div>-->
<!--                        <div class="select-body">-->
<!--                          <div class="select-inner js-scrollbar">-->
<!--                            <div-->
<!--                              v-for="item in allPartners"-->
<!--                              :key="item.id"-->
<!--                              :class="[-->
<!--                                'select-option',-->
<!--                                {'is-selected': item.active},-->
<!--                              ]"-->
<!--                              @click="findCurrentPayerSelect(item)">-->
<!--                              <span class="select-option__name">{{-->
<!--                                item.companyName-->
<!--                              }}</span>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                    </div>

                    <div
                      v-if="currentPayerOptionsSelect.payerType === 'PARTICIPANT'"
                      class="form-control-group form-control-group_clients" :class="{'is-error': validErrorInvoice.clientName}">

                      <input type="text" class="form-control" @blur="getClientName(templateCreateInvoice.payer.participant)" placeholder="Введите имя" v-model="templateCreateInvoice.payer.participant">

                    </div>

                  </div>
                  <div class="control-panel_description">
                    <div class="description-currency">
                      <span class="name">Currency: </span>
                        <ClassicSelect
                            :key="selectedCurrencyItem.id"
                            custom-width="100px"
                            :items="currencySelectItems"
                            :selected-item="selectedCurrencyItem"
                            @select-item="selectInvoiceCurrency"/>
                    </div>
                    <div class="description-date">
                      <span>Deadline:</span>
                      <div class="form-control-wrap" :class="{'is-error': validErrorInvoice.deadline}">
                        <input
                          type="text"
                          placeholder="Date"
                          v-model="templateCreateInvoice.deadline"
                          @blur="
                            convectorFormat($event.target.value)
                          "
                          class="form-control js-datepicker-single" />
                        <div class="form-control-icon">
                          <svg class="icon icon-calendar">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="(currentPayerOptionsSelect.payerType === 'OPERATOR') && (currentPayerSelect.tin.length !== 0 || currentPayerSelect.vrn.length !== 0 || currentPayerSelect.phone.length !== 0 || currentPayerSelect.address.length !== 0)"
                  class="payer-block_control-content">
                  <div class="control-content_block">
                    <span>TIN:</span>
                    <span>{{ currentPayerSelect.tin }}</span>
                  </div>
                  <div class="control-content_block">
                    <span>VRN:</span>
                    <span>{{ currentPayerSelect.vrn }}</span>
                  </div>
                  <div class="control-content_block">
                    <span>Mobile:</span>
                    <span>{{ currentPayerSelect.phone }}</span>
                  </div>
                  <div class="control-content_block">
                    <span>Address:</span>
                    <span>{{ currentPayerSelect.address }}</span>
                  </div>
                </div>
              </div>

              <div class="payer-block__behalf">
                <div class="payer-block_title">
                  <span>Behalf of</span>
                </div>

                <div
                    :class="['select-wrapper', {'is-active': selects.clients}]"
                    style="max-width: 240px"
                    @click="openSelects('clients')"
                >
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                        templateCreateInvoice.behalfOf.length > 0 && templateCreateInvoice.behalfOf.length !== behalfList.length
                            ? templateCreateInvoice.behalfOf.map((p) => p.participantName).join(', ')
                            : 'All Clients'
                      }}
                    </span>
                    <span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                      </svg>
                    </span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                      <div class="select-option">
                        <label
                            class="form-control-checkbox form-control-checkbox-add-flight"
                            @click.prevent.stop="templateCreateInvoice.behalfOf = behalfList"
                        >
                          <input
                              type="checkbox"
                              :checked="templateCreateInvoice.behalfOf.length === behalfList.length"
                          />
                          <span class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg>
                          </span>
                          <span class="select-option__name">All Clients</span>
                        </label>
                      </div>
                      <div
                          v-for="p in behalfList"
                          :key="p.id"
                          :class="[
                          'select-option',
                          {
                            'is-selected': false
                          },
                        ]">
                        <label
                               class="form-control-checkbox form-control-checkbox-add-flight"
                               @click.prevent.stop="() => {
                                  if(templateCreateInvoice.behalfOf.length === behalfList.length){
                                    templateCreateInvoice.behalfOf = []
                                  }
                                  if (!templateCreateInvoice.behalfOf.map((item) => item.participantId).includes(p.participantId)) {
                                      templateCreateInvoice.behalfOf.push({
                                        id: p.id,
                                        participantId: p.participantId,
                                        participantName: p.participantName
                                      })
                                  } else {
                                    templateCreateInvoice.behalfOf = templateCreateInvoice.behalfOf.filter((i) => !(i.participantId === p.participantId))
                                  }
                              }">
                          <input
                              type="checkbox"
                              :checked="
                                templateCreateInvoice.behalfOf.length === behalfList.length ? false : templateCreateInvoice.behalfOf.map((item) => item.participantId).includes(p.participantId)
                              "
                              @click.prevent.stop />
                          <span
                            class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg>
                          </span>
                          <span class="select-option__name">{{p.participantName}}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="behalf__clients-pax">
                  <span class="clients-pax__title">Clients ({{templateCreateInvoice.behalfOf.length}} Pax): </span>

                  <span class="clients-pax__disc">
                    {{templateCreateInvoice.behalfOf.map((p) => p.participantName).join(', ')}}
                  </span>
                </div>

              </div>
              <div :class="[
                      'payment-on-spot__checkbox-wrapper',
                      {'checkbox-charge--error': templateCreateInvoice.chargeError},
                    ]">
                <div class="form-control-group form-control-group--radio">
                  <label
                      class="form-control-radio"
                      @click="templateCreateInvoice.chargeType = 'STANDARD'">
                    <input
                        type="radio"
                        name="payment-options"
                        value="standard"
                        :checked="templateCreateInvoice.chargeType === 'STANDARD'" />
                    <span class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                  >Standard</span
                  >
                  </label>
                  <label
                      class="form-control-radio"
                      @click="templateCreateInvoice.chargeType = 'SPOT'">
                    <input
                        type="radio"
                        name="payment-options"
                        value="paymentOnSpot"
                        :checked="templateCreateInvoice.chargeType === 'SPOT'" />
                    <span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                  >Payment on spot</span
                  >
                  </label>
                  <label
                      v-if="client.contract !== 'UAE'"
                      class="form-control-radio"
                      @click="templateCreateInvoice.chargeType = 'AUTH_FORM'">
                    <input
                        type="radio"
                        name="payment-options"
                        value="authorizationForm"
                        :checked="templateCreateInvoice.chargeType === 'AUTH_FORM'" /><span
                      class="form-control-radio__box"></span
                  ><span class="form-control-radio__name"
                  >Authorization form</span
                  >
                  </label>
                </div>
              </div>
              <div class="payer-block_services">
                <div class="payer-block_services-header">
                  <div class="services-header_title">
                    <span>Description of Services</span>
                  </div>
                  <div class="services-header_qty">
                    <span>Qty</span>
                  </div>
                  <div class="services-header_price">
                    <span>Price</span>
                  </div>
                  <div class="services-header_date">
                    <span>Dates</span>
                  </div>
                  <div class="services-header_amount">
                    <span>Amount</span>
                  </div>
                  <div class="services-header_amount">
                    <span>To be paid</span>
                  </div>
                  <div class="services-header_deleted"></div>
                </div>
                <draggable v-model="templateCreateInvoice.services" handle=".movethis">
                  <div
                      v-for="(services, index) in templateCreateInvoice.services"
                      :key="services.id"
                      class="payer-block_services-body"
                  >
                    <div class="services-body_select">
                      <v-select
                          v-model="services.type"
                          :options="categoriesServicesBreakdown"
                          :reduce="(item) => item.type"
                          :filterable="false"
                          :clearable="false"
                          :searchable="false"
                          @input="changeServiceNameByType(services)"
                          label="name"
                          placeholder=""
                          class="new-select"
                      >
                        <template #open-indicator>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none">
                            <path
                                d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                fill="#606060" />
                          </svg>
                        </template>
                        <template #option="option">
                          <div class="select__item d-center">
                            <svg v-if="option.type === 'CUSTOM' || option.type === 'ADDITIONAL_OPTION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                            >
                            <svg v-if="option.type === 'OTHER_EXPENSES' || option.type === 'ADDITIONAL_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                            >
                            <svg v-if="option.type === 'AIRPORT_VIP_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                            >
                            <svg v-if="option.type === 'TRANSFER'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                            >
                            <svg v-if="option.type === 'FLIGHT'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                            >
                            <svg v-if="option.type === 'MAINLAND'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                            >
                            <svg v-if="option.type === 'ISLAND' || option.type === 'ISLAND_TRANSFER' || option.type === 'ISLAND_DAY_TRIP'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                            >
                            <svg v-if="option.type === 'SAFARI' || option.type === 'SAFARI_ACTIVITY'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                            >
                            <svg v-if="option.type === 'CLIMBING' || option.type === 'CLIMBING_RENTAL' || option.type === 'CLIMBING_EXTRA'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                            >
                            <svg v-if="option.type === 'EXTRA_ACCOMMODATION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                            >
                            {{ option.name }}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div class="selected d-center">
                            <svg v-if="option.type === 'CUSTOM' || option.type === 'ADDITIONAL_OPTION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                            >
                            <svg v-if="option.type === 'OTHER_EXPENSES' || option.type === 'ADDITIONAL_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                            >
                            <svg v-if="option.type === 'AIRPORT_VIP_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                            >
                            <svg v-if="option.type === 'TRANSFER'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                            >
                            <svg v-if="option.type === 'FLIGHT'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                            >
                            <svg v-if="option.type === 'MAINLAND'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                            >
                            <svg v-if="option.type === 'ISLAND' || option.type === 'ISLAND_TRANSFER' || option.type === 'ISLAND_DAY_TRIP'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                            >
                            <svg v-if="option.type === 'SAFARI' || option.type === 'SAFARI_ACTIVITY'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                            >
                            <svg v-if="option.type === 'CLIMBING' || option.type === 'CLIMBING_RENTAL' || option.type === 'CLIMBING_EXTRA'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                            >
                            <svg v-if="option.type === 'EXTRA_ACCOMMODATION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                            >
                            <!--                          {{ option.name }}-->
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="services-body_description">
                      <div class="form-control-wrap" :class="{'is-error': !templateCreateInvoice.services[index].name.length > 0 || templateCreateInvoice.services[index].isError}">
                        <textarea type="text" data-textarea-autoresize resize="none" wrap="soft" class="resizable-textarea" @input="textAreaAutoSize($event)" placeholder="note" @blur="getNoteServices()" v-model="templateCreateInvoice.services[index].name" />
                      </div>
                    </div>
                    <div class="services-body_qty">
                      <div class="form-control-wrap">
                        <the-mask
                            type="text"
                            class="form-control form-control-time maskField"
                            :mask="'##'"
                            :tokens="{'#': {pattern: /[A-Za-z0-9]/}}"
                            v-model="templateCreateInvoice.services[index].quantity"
                            @input="findCurrentSelectsQuality(services, templateCreateInvoice)"
                            placeholder="1" />
                      </div>
                    </div>
                    <div class="services-body_price">
                      <div class="form-control-wrap">
                        <span>{{getCurrencySign(templateCreateInvoice.currencyType)}}</span>
                        <input
                            @input="onCountPrice(services, templateCreateInvoice)"
                            type="number"
                            class="form-control"
                            placeholder="0"
                            v-model="templateCreateInvoice.services[index].price"
                        >
                      </div>
                    </div>
                    <div
                        class="services-body_date"
                        :class="{'valid-error': !(parseDate(templateCreateInvoice.services[index].startDate) <= parseDate(templateCreateInvoice.services[index].endDate))}">
                      <div class="form-control-wrap first">
                        <input
                            type="text"
                            placeholder="From"
                            v-model="templateCreateInvoice.services[index].startDate"
                            @blur="
                            templateCreateInvoice.services[index].startDate = $event.target.value
                          "
                            class="form-control js-datepicker-single" />
                      </div>
                      <span>-</span>
                      <div class="form-control-wrap second">
                        <input
                            type="text"
                            placeholder="To"
                            v-model="templateCreateInvoice.services[index].endDate"
                            @blur="
                            templateCreateInvoice.services[index].endDate = $event.target.value
                          "
                            class="form-control js-datepicker-single"
                        />
                        <div class="form-control-icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-calendar">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="services-body_amount">

                      <template v-if="templateCreateInvoice.services[index].amount">
                        <span>{{getCurrencySign(templateCreateInvoice.currencyType)}}</span>
                        <span>{{templateCreateInvoice.services[index].amount === null ? ' - ' : numberWithCommas(templateCreateInvoice.services[index].amount)}}</span>
                      </template>

                    </div>
                    <div class="services-body_payable">
                      <div class="form-control-wrap">
                        <span>{{getCurrencySign(templateCreateInvoice.currencyType)}}</span>
                        <input
                            @input="onCountPayable(services, templateCreateInvoice, index)"
                            type="number"
                            class="form-control"
                            :placeholder="0"
                            v-model="templateCreateInvoice.services[index].amountPayable"
                        >
                      </div>
                    </div>
                    <div class="movethis-wrapper">
                      <button
                          type="button"
                          class="movethis-button movethis">
                        <svg width="1em" height="1em" class="icon icon-movethis">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-move"></use>
                        </svg>
                      </button>
                    </div>
                    <div class="services-body_delete">
                      <button
                          type="button"
                          class="btn btn--remove"
                          @click="deleteServices(index, services, templateCreateInvoice)"
                      >
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </draggable>

                <div class="payer-block_services-options">
                  <div class="services-options_btn">
                    <button
                        type="button"
                        class="btn btn--rounded2 btn--green btn--add"
                        @click="addServices"
                        >
                      <svg width="1em" height="1em" class="icon icon-plus-o-white">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                      </svg>
                      <span>Add Services</span>
                    </button>
                  </div>
                  <div class="">
                    <div class="services-options__block">
                      <div class="services-options_deposit">
                        <div class="deposit-name">
                          <span>Current Deposit:</span>
                        </div>
                        <div class="deposit-current">
                          <div
                            :class="[
                            'form-control-wrap form-control-wrap--days',
                            {'is-error': false},
                          ]">
                          <input
                              type="number"
                              :placeholder="templateCreateInvoice.currentDeposit"
                              @input="templateCreateInvoice.currentDeposit = $event.target.value === '' ? 0 : $event.target.value"
                              :value="templateCreateInvoice.currentDeposit"
                              class="form-control" />
                          <div class="form-control-label-descr">
                            <span>
                              {{getCurrencySign(templateCreateInvoice.currencyType)}}
                            </span>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div class="services-options__block--separator"></div>
                      <div class="services-options_total">
                        <div class="total-name">
                          <span>Total amount:</span>
                        </div>
                        <div class="total-line"></div>
                        <div class="total-result">
                          <template v-if="templateCreateInvoice.totalAmount">
                            <span>
                              {{getCurrencySign(templateCreateInvoice.currencyType)}}
                              {{templateCreateInvoice.totalAmount === null ? '' : numberWithCommas(templateCreateInvoice.totalAmount)}}
                            </span>
                          </template>
                          <template v-else>
                            <span>0</span>
                          </template>
                        </div>
                      </div>
                      <div class="services-options_payable">
                        <div class="total-name">
                          <span>Amount Payable:</span>
                        </div>
                        <div class="total-line"></div>
                        <div class="total-result">
                          <template v-if="templateCreateInvoice.totalAmountPayable">
                            <span>
                              {{getCurrencySign(templateCreateInvoice.currencyType)}}
                              {{templateCreateInvoice.totalAmountPayable === null ? '' : numberWithCommas(templateCreateInvoice.totalAmountPayable)}}
                            </span>
                          </template>
                          <template v-else>
                            <span>0</span>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__summary__total__main breakdown-cost__summary__total__main_2">
                      <div class="breakdown-cost__summary__text-swich">
                        Allow the client to pay for the tour via Stripe, turn it
                        ON only when all hotels have confirmed your pre-booking.
                      </div>
                      <div class="switch">
                        <label class="switch-label"
                        ><input type="checkbox" v-model="templateCreateInvoice.allowStripe" />
                          <span class="switch-inp"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="payer-block_services-footer">
                  <div class="services-footer_desc">
                    <span>Note: Bank commissions of the Payer's and Receiver's bank are payable by the Payer.</span>
                    <span>By paying this bill, you are accepting our Terms and Conditions: <a target="_blank" href="https://altezza.travel/en/terms-and-conditions">https://altezza.travel/en/terms-and-conditions</a></span>
                  </div>
                  <div class="services-footer_confirm">
                    AMOUNT PAYABLE:
                      <template v-if="templateCreateInvoice.totalAmountPayable">
                        <span>{{getCurrencySign(templateCreateInvoice.currencyType)}}</span>
                        <span>{{templateCreateInvoice.totalAmountPayable === null ? '' : numberWithCommas(templateCreateInvoice.totalAmountPayable)}}</span>
                      </template>
                      <template v-else>
                        0
                      </template>
                      should be paid before
                        <template v-if="templateCreateInvoice.deadline">
                        {{templateCreateInvoice.deadline === null ? '' : parseDateToString(templateCreateInvoice.deadline)}}
                      </template>
                      <template v-else>
                         deadline
                      </template>
                      in order to confirm your booking.
                  </div>
                  <div class="services-footer_note">
                    <div class="note-title">
                      <svg
                          class="icon icon-important important-icon">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                      <span>NOTE</span>
                    </div>
                    <div class="note-text">
                      <textarea type="text" placeholder="Type a note" v-model="templateCreateInvoice.note"/>
                    </div>
                  </div>
                  <div class="services-footer_btn">
                      <span v-if="!hasClientContract" class="invoice-contract-error">
                        The program contract type is missing
                      </span>
                      <button
                          type="button"
                          :disabled="!hasClientContract"
                          @click="createInvoices"
                          class="btn btn--green">
                        <span>Create Invoice</span>
                      </button>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vuex from 'vuex'
import {TheMask} from 'vue-the-mask'
import {debounce} from "lodash";
import ATLoader from '@/components/Loaders/Loader'
import {
  actionTypes as actionTypesBanks,
  getterTypes as getterTypesBanks,
} from '@/store/modules/banks'
import {
  actionTypes as actionTypesPartners,
  getterTypes as getterTypesPartners,
} from '@/store/modules/partners'
import {
  actionTypes as actionTypesSettings,
  getterTypes as getterTypesSettings,
} from '@/store/modules/settings'
import Lightpick from 'lightpick'
import {actionTypes as actionTypesInvoices, getterTypes as getterTypesInvoice} from "@/store/modules/invoices";
import {format, parse} from "date-fns";
import draggable from "vuedraggable";
import {getPlaceholderTemplates} from "../../common/helpers/invoiceServicePlaceholders"
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect.vue";
import {CURRENCY_SELECT_ITEMS, getCurrencySign} from '../../common/helpers/currency'
import {getBanksByContractType} from '@/common/helpers/banks'

export default {
  name: 'ATCreatedInvoices',
  created() {
    this.getClient({id: this.$route.params.id}).then(
      () => (

        (this.currentParticipantsSelect = this.participants[0]),
        (this.templateCreateInvoice.currencyType = this.client.program.currency),
            this.ensureSelectedBank(this.availableBanks),
            (this.templateCreateInvoice.userId = this.client.userId),
            (this.templateCreateInvoice.clientId = this.client.id),
            (this.programTourStart = this.client.program.tourStart),
            (this.programTourFinish = this.client.program.tourFinish),
            this.findBehalfList(),
          this.autoAddServices()
      )
    )
  },
  data() {
    return {
      isErrorInFields: false,
      currencySelectItems: CURRENCY_SELECT_ITEMS,
      placeholderTemplates: getPlaceholderTemplates(),
      now: Date.now(),
      activeBtnCreateInvoice: true,
      programTourStart: '',
      programTourFinish: '',
      collapse: {
        information: false,
        breakdownCost: false
      },
      selects: {
        clients: false,
      },
      invoicePrice: null,
      show0: false,
      showNames: false,
      tourStart: '',
      tourFinish: '',
      commisionInclude: false,
      allowStripe: false,
      payerOptions: [
        {
          type: 'OPERATOR',
          name: 'Operator',
        },
        {
          type: 'PARTICIPANT',
          name: 'Client',
        },
      ],
      isActiveSelectServices: false,
      currentSelectsServices: {},
      isActiveSelectQuality: false,
      currentSelectsQuality: {},
      isActiveSelectParticipants: false,
      currentParticipantsSelect: {},
      isActiveSelectPayerOptions: false,
      currentPayerOptionsSelect: '',
      isActiveSelectBank: false,
      currentBankSelect: {},
      isActiveSelectPayer: false,
      currentPayerSelect: {},
      validErrorInvoice: {
        deadline: true,
        price: true,
        date: true,
        clientName: true,
        noteServices: true,
        bank: false,
      },
      currentBehalfList: [],
      templateCreateInvoice: {
        currencyType: "",
        currentDeposit: 0,
        clientId: null,
        bankId: null,
        userId: null,
        status: 'SENT',
        paymentMethod: null,
        payer: {
          payerType: "",
          participant: "",
          operatorId: null
        },
        deadline: "",
        services: [],
        note: "",
        dateOfPayment: "",
        allowStripe: false,
        behalfOf: [],
        chargeType: null,
        chargeError: false,
      },
    }
  },
  components: {ClassicSelect, ATLoader, TheMask, draggable},
  computed: {
    ...Vuex.mapGetters({
      allBanks: getterTypesBanks.allBanks,
      allPartners: getterTypesPartners.allPartners,
      participants: getterTypesSettings.participants,
      client: getterTypesSettings.client,
      calculationResult: getterTypesSettings.calculationResult,
      isLoadingClient: getterTypesSettings.isLoadingClient,
      categoriesServicesBreakdown: getterTypesSettings.categoriesServicesBreakdown,
      invoiceServices: getterTypesSettings.invoiceServices,
      newInvoices: getterTypesInvoice.newInvoices,
      behalfList: getterTypesInvoice.behalfList
    }),
    hasClientContract() {
      return Boolean(this.client && this.client.contract)
    },
    availableBanks() {
      return getBanksByContractType(this.allBanks, this.client && this.client.contract)
          .filter((bank) => Array.isArray(bank.availableCurrencies) &&
              bank.availableCurrencies.includes(this.templateCreateInvoice.currencyType))
    },
    discountInSorteredParticipantPresent() {
      return this.sorteredParticipants.filter((item) => item.personalDiscount)
          .length
    },
    sorteredParticipants() {
      if (this.calculationResult && this.calculationResult.breakdownCost) {
        const dlfkldkfl =
            this.calculationResult.breakdownCost.summary.participantCosts.sort((a, b) =>
                a.id < b.id ? -1 : 1
            )
        return this.calculationResult.breakdownCost.summary.participantCosts.sort(
            (a, b) => (a.id < b.id ? -1 : 1)
        )
      } else {
        return []
      }
    },
    participantsPax(){
      let ad = this.participants.filter(p => p.ageType === 'adult')
      let tn = this.participants.filter(p => p.ageType === 'teenager')
      let cl = this.participants.filter(p => p.ageType === 'child')
      let pax = []
      if (ad.length > 0) pax.push(`${ad.length} Adult`)
      if (tn.length > 0) pax.push(`${tn.length} Teenager`)
      if (cl.length > 0) pax.push(`${cl.length} Child`)
      return pax
    },
    selectedCurrencyItem() {
      return this.currencySelectItems.find((currency) => currency.id === this.templateCreateInvoice.currencyType)
          || this.currencySelectItems[0]
    },
    findQualityLIst(){
      let i = 0;
      let list = []
      while (i < this.participants.length) {
        i++;
        list.push({
            'name': i,
            'value': i
          })
      }
      return list
    },
  },
  watch: {
    availableBanks(banks) {
      this.syncSelectedBank(banks)
    },
    'templateCreateInvoice.currencyType'(currency, previousCurrency) {
      if (previousCurrency && currency !== previousCurrency) {
        this.resetSelectedBank()
      }
    },
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      findBanks: actionTypesBanks.findBanks,
      findPartners: actionTypesPartners.findPartners,
      getClient: actionTypesSettings.getClient,
      createNewInvoices: actionTypesInvoices.createNewInvoices,
      getBehalfList: actionTypesInvoices.getBehalfList
    }),
    autoresizeAllTextarea() {
     setTimeout(() => {
       const textareas = document.querySelectorAll("[data-textarea-autoresize]")
       textareas.forEach(textarea => {
         this.textAreaAutoSizeElement(textarea)
       })
     }, 0)
    },
    textAreaAutoSizeElement(el) {
      el.style.height = "14px";
      el.style.height = (el.scrollHeight) + "px";
    },
    textAreaAutoSize(el) {
      const textarea = el.target;
      textarea.style.height = "14px";
      textarea.style.height = (textarea.scrollHeight) + "px";
    },
    changeServiceNameByType(service) {
      service.name = this.getInputTextByServiceType(service.type);
      this.autoresizeAllTextarea();
    },
    getInputTextByServiceType(type) {
      const text = this.placeholderTemplates.get(type);
      return text || 'none';
    },
    openSelects(type = false){
      this.selects = {
        clients: false,
        [type]: !this.selects[type],
      }
    },
    findBehalfList(){
      this.getBehalfList({
        clientId: this.templateCreateInvoice.clientId
      }).then((res) => {
        this.templateCreateInvoice.behalfOf = res.data
      })
    },
    getNoteServices(){
     let services = this.templateCreateInvoice.services.filter(s => s.name.length > 0)
      services.length === this.templateCreateInvoice.services.length ? this.validErrorInvoice.noteServices = false : this.validErrorInvoice.noteServices = true
    },
    getClientName(name){
      name.length > 0 ? this.validErrorInvoice.clientName = false : this.validErrorInvoice.clientName = true
    },
    parseDate(date) {
      if (!date) return
      var parts = date.match(/(\d+)/g)
      // console.log(parts)
      // console.log(new Date(parts[2], parts[1]-1, parts[0]))
      return new Date(parts[2], parts[1]-1, parts[0])
      // return new Date(format(parse(date, 'dd.MM.yyyy', new Date()), 'yyyy, MM, dd'))
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    createInvoices(){
      if (!this.hasClientContract) return

      const fields = [...this.placeholderTemplates.values()];
      const filledFields = this.templateCreateInvoice.services.map((service) => service.name);

      const fieldsWithError = filledFields.filter((item) => fields.includes(item));
      this.templateCreateInvoice.services.forEach((item, index) => {
        item.isError = fieldsWithError.includes(item.name);
      })

      this.templateCreateInvoice.chargeError = this.templateCreateInvoice.chargeType === null;
      const isBankCurrencyValid = this.validateBankCurrency()
      const hasFormErrors =
          this.validErrorInvoice.deadline ||
          this.validErrorInvoice.clientName ||
          this.validErrorInvoice.noteServices

      if (hasFormErrors || fieldsWithError.length > 0 || this.templateCreateInvoice.chargeError || !isBankCurrencyValid) {
        this.scrollToFirstValidationError()
        return
      }

      this.templateCreateInvoice.services.map(s => {
        if (s.amountPayable === null) s.amountPayable = 0
      })

      this.createNewInvoices(this.templateCreateInvoice).then(
          () => this.$router.push(
              { path: `/changeInvoice/${this.newInvoices.id }`}
          )
      )
    },
    convectorFormat(date) {
      let data1 = this.parseDate(date)
      let data2 = new Date(this.now)
      let day1D = data1.getDate()
      let day2D = data2.getDate()
      let day1Y = data1.getFullYear()
      let day2Y = data2.getFullYear()
      let day1M = data1.getMonth()
      let day2M = data2.getMonth()
      if (date) {
        if (day1Y >= day2Y) {
          if (day1Y === day2Y) {
            if (day1M >= day2M) {
              if (day1M === day2M) {
                if (day1D >= day2D) {
                  this.templateCreateInvoice.deadline = date
                  this.validErrorInvoice.deadline = false
                }else {
                  this.templateCreateInvoice.deadline = date
                  this.validErrorInvoice.deadline = true
                }
              }
              else if (day1M > day2M) {
                this.templateCreateInvoice.deadline = date
                this.validErrorInvoice.deadline = false
              }else {
                this.templateCreateInvoice.deadline = date
                this.validErrorInvoice.deadline = true
              }
            }
          }
          else if (day1Y > day2Y) {
            this.templateCreateInvoice.deadline = date
            this.validErrorInvoice.deadline = false
          }else {
            this.templateCreateInvoice.deadline = date
            this.validErrorInvoice.deadline = true
          }
        } else {
          this.templateCreateInvoice.deadline = date
          this.validErrorInvoice.deadline = true
        }
      }
    },
    onChangeComission() {
      if (this.commisionInclude) {
        this.calcTemplatePriceHandler()
      } else {
        this.calcTemplatePriceHandler()
      }
    },
    removeFractional(price) {
      return Math.ceil(price)
    },
    numberWithCommas(x) {
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onCountPrice(services, template){
      this.countPrice(services, template)
    },
    countPrice: debounce((services, template) => {
      services.amount = services.quantity * services.price

      const array = template.services.map(a => a.amount)
      const initialValue = 0;
      template.totalAmount = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
    }, 350),
    onCountPayable(services, template, index){
      this.templateCreateInvoice.services[index].amountPayable = services.amountPayable
      this.countPayable(services, template)
    },
    countPayable: debounce((services, template) => {
      if (services.amountPayable !== '') services.amountPayable = services.amountPayable * 1

      const array = template.services.map(a => a.amountPayable)
      const initialValue = 0;
      template.totalAmountPayable = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
    }, 350),
    autoAddServices(){
      this.updateDatePickers()
      if (this.invoiceServices.length > 0) {
        this.invoiceServices.map(s => {
          if (s.type !== 'CUSTOM') {
            this.templateCreateInvoice.services.push({
              name: this.getInputTextByServiceType(s.type),
              quantity: 1,
              price: null,
              startDate: "",
              endDate: "",
              amountPayable: null,
              amountPaid: 0,
              amount: null,
              type: s.type
            })
          }
          this.autoresizeAllTextarea();
        })
      }
    },
    addServices() {
      this.updateDatePickers()
      this.templateCreateInvoice.services.push({
        name: "",
        quantity: 1,
        price: null,
        startDate: "",
        endDate: "",
        amountPayable: null,
        amountPaid: 0,
        amount: null,
        type: ''
      })
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD.MM.yyyy',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
    deleteServices(index, services, template) {
      this.templateCreateInvoice.services.splice(index, 1)
      const array = template.services.map(a => a.amount)
      const arrayAmountPayable = template.services.map(a => a.amountPayable)
      const initialValue = 0;
      template.totalAmount = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
      template.totalAmountPayable = arrayAmountPayable.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
      this.getNoteServices()
      this.autoresizeAllTextarea();
    },
    isCurrentSelectsServices(index) {
      this.templateCreateInvoice.services[index].isActiveSelectServices = !this.templateCreateInvoice.services[index].isActiveSelectServices
    },
    isCurrentSelectsQuality(index) {
      this.templateCreateInvoice.services[index].isActiveSelectQuality = !this.templateCreateInvoice.services[index].isActiveSelectQuality
    },
    isCurrentBankSelect() {
      this.isActiveSelectBank = !this.isActiveSelectBank
    },
    isCurrentPayerSelect() {
      this.isActiveSelectPayer = !this.isActiveSelectPayer
    },
    isCurrentPayerOptionsSelect() {
      this.isActiveSelectPayerOptions = !this.isActiveSelectPayerOptions
    },
    isCurrentParticipantsSelect() {
      this.isActiveSelectParticipants = !this.isActiveSelectParticipants
    },
    findCurrentParticipantsSelect(participant) {
      this.currentParticipantsSelect = participant
      this.templateCreateInvoice.payer.participant = participant.name
      this.templateCreateInvoice.payer.operatorId = null
    },
    findCurrentBankSelect() {
      const shouldValidateCurrency = this.validErrorInvoice.bank
      this.currentBankSelect = this.availableBanks.find(b => b.id === this.templateCreateInvoice.bankId)
      if (shouldValidateCurrency) {
        this.validateBankCurrency()
      }
    },
    selectInvoiceCurrency(currency) {
      if (currency.id === this.templateCreateInvoice.currencyType) return

      const shouldValidateCurrency = this.validErrorInvoice.bank
      this.templateCreateInvoice.currencyType = currency.id
      this.resetSelectedBank()
      if (shouldValidateCurrency) {
        this.validateBankCurrency()
      }
    },
    validateBankCurrency() {
      const selectedBank = this.availableBanks.find(bank => bank.id === this.templateCreateInvoice.bankId)
      const availableCurrencies = Array.isArray(selectedBank && selectedBank.availableCurrencies)
          ? selectedBank.availableCurrencies
          : []
      const isCurrencyAvailable = Boolean(
          selectedBank &&
          availableCurrencies.includes(this.templateCreateInvoice.currencyType)
      )

      this.validErrorInvoice.bank = !isCurrencyAvailable
      return isCurrencyAvailable
    },
    scrollToFirstValidationError() {
      this.$nextTick(() => {
        const firstError = this.$el.querySelector(
            '.invoice-bank-select--error, .form-control-group.is-error, .form-control-wrap.is-error, .checkbox-charge--error'
        )

        if (firstError) {
          firstError.scrollIntoView({behavior: 'smooth', block: 'center'})
        }
      })
    },
    findCurrentPayerSelect() {
      this.templateCreateInvoice.payer.participant = null
      this.templateCreateInvoice.payer.operatorId = this.currentPayerSelect.id
    },
    loadCurrentPayerOptionsSelect(type) {
      this.currentPayerOptionsSelect = this.templateCreateInvoice.payer
      this.templateCreateInvoice.payer.participant = ''
      this.templateCreateInvoice.payer.payerType = type.type
      this.templateCreateInvoice.payer.operatorId = null
    },
    findCurrentPayerOptionsSelect() {
      if (this.templateCreateInvoice.payer.payerType === 'OPERATOR') {
        this.validErrorInvoice.clientName = false
        this.templateCreateInvoice.payer.participant = null
        this.templateCreateInvoice.payer.operatorId = this.allPartners[0].id
        this.currentPayerOptionsSelect = this.templateCreateInvoice.payer
        this.currentPayerSelect = this.allPartners.find(p => p.id === this.templateCreateInvoice.payer.operatorId)
      }

      if (this.templateCreateInvoice.payer.payerType === 'PARTICIPANT') {
        this.templateCreateInvoice.payer.participant = ''
        this.validErrorInvoice.clientName = true
        this.templateCreateInvoice.payer.operatorId = null
        this.currentPayerOptionsSelect = this.templateCreateInvoice.payer
      }
    },
    findCurrentSelectsServices(service, index) {
      this.templateCreateInvoice.services[index].type = service.type
      this.templateCreateInvoice.services[index].categoriesName = service.name
    },
    findCurrentSelectsQuality(services, template) {
      if (services.quantity === '') {
        services.quantity = 1
      }
      this.countPrice(services, template)
    },
    findAllBanks() {
      this.findBanks().then(() => {
        this.ensureSelectedBank(this.availableBanks)
      })
    },
    ensureSelectedBank(banks = this.availableBanks) {
      const selectedBank = banks.find((bank) => bank.id === this.templateCreateInvoice.bankId) || banks[0]
      this.currentBankSelect = selectedBank || {}
      this.templateCreateInvoice.bankId = selectedBank ? selectedBank.id : null
    },
    syncSelectedBank(banks = this.availableBanks) {
      const selectedBank = banks.find((bank) => bank.id === this.templateCreateInvoice.bankId)
      this.currentBankSelect = selectedBank || {}
      if (!selectedBank) {
        this.templateCreateInvoice.bankId = null
      }
    },
    resetSelectedBank() {
      this.currentBankSelect = {}
      this.templateCreateInvoice.bankId = null
    },
    findAllPartners() {
      this.findPartners().then(
        () => {
          this.currentPayerSelect = this.allPartners[0],
          this.loadCurrentPayerOptionsSelect(this.payerOptions[1])
        }
      )
    },
  },
  mounted() {
    this.findAllBanks()
    this.findAllPartners()

    window.addEventListener('click', (event) => {
      event.stopPropagation()
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          clients: false,
        }
      }
    })

    this.currentPayerOptionsSelect = this.payerOptions[1]
  },
}
</script>
<style lang="scss" scoped>
.movethis {
  &-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border-bottom: 1px solid #E4E4E4;
    border-right: 1px solid #E4E4E4;
  }
  &-button {
    width: 36px;
    height: 36px;
    border: 1px solid #DDDDDD;
    border-radius: 8px;
  }
}
.icon-movethis {
  font-size: 1.4rem;
  color: #639a05;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
}
.payment-on-spot__checkbox-wrapper {
  margin-bottom: 40px;
}

.resizable-textarea {
  font-size: 12px;
  width: 100%;
  height: 20px;
  line-height: 18px;
  resize: none;
  overflow: hidden;
  outline: none;
  border: none;
}
.form-control-wrap.is-error textarea{
  background: #fde8e8;
}
.form-control-wrap.is-error {
  background: #fde8e8;
}

.invoice-bank-select--error {
  border-radius: 3px;
  background-color: rgba(244, 152, 152, 0.2);
}

.invoice-contract-error {
  max-width: 28rem;
  margin-left: 2rem;
  color: #C0392B;
  font-size: 1.2rem;
  line-height: 1.4;
  text-align: right;
}

.checkbox-charge--error {
  position: relative;
  background-color: rgba(244, 152, 152, 0.2);
  padding: 10px 0;
  width: fit-content;
}
</style>
